import React, { useState, useEffect } from "react";
import wx from 'weixin-js-sdk';
import dayjs from 'dayjs';
import axios from 'axios';
import { Spin, } from 'antd';
import { Bar, Column } from "@antv/g2plot";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from 'react-router-dom';
import { CloseCircleFilled, QuestionCircleOutlined } from '@ant-design/icons';
import styles from "./index.less";

import TitleSvg from './TitleSvg';
import CommonUtils from '@/utils/common';

function zoomOutMobile() {
  const ua = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
  ? 'isMobile'
  : 'isPc';
  if (ua === 'isMobile') {
    var viewport = document.querySelector('meta[name="viewport"]');

    if ( viewport ) {
      viewport.content = "initial-scale=0.1";
      viewport.content = "width=1200";
    }
  }
}

// PC端 禁止页面缩放
function disableZoom () {
  window.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && (e.which === 61 || e.which === 107 || e.which === 173 || e.which === 109 || e.which === 187 || e.which === 189)) {  
      e.preventDefault();
    }
  }, false);
  const handleWheel = function(e) {
    if(e.ctrlKey || e.metaKey)
        e.preventDefault();
  };
  window.addEventListener("wheel", handleWheel, {passive: false});
}

function Recyclepdf() {



  const [info, setInfo] = useState({});
  const [dateArr1, setDateArr1] = useState([]);
  const [dateArr2, setDateArr2] = useState([]);
  const [spuList, setSpuList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [ua, setUa] = useState('');
  const [barChartH, setBarChartH] = useState(0);
  const [pcTipVisible, togglePcTip] = useState(false);
  const [isBlank, setIsBlack] = useState(false);
  const [shareTipVisible, toggleShareTip] = useState(false);
  const [spuWidth, setSpuWidth] = useState('');
  const [xiaojiWidth, setXiaojiWidth] = useState('');

  const location = useLocation();
  const code = location.search.split('code=')[1];
  const currentTime = CommonUtils.getUrlParam({ url: location.search, key: 'currentTime'});

  const locationIsBlack = CommonUtils.getUrlParam({ url: location.search, key: 'isBlank'});

  const url = window.location.href.split('#')[0];
  const encodedUrl = encodeURIComponent(url);
  
// console.log('location:',isBlank)
  useEffect(() => {
    zoomOutMobile();
    disableZoom();
    setIsBlack(locationIsBlack);

    const ua = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    ? 'isMobile'
    : 'isPc';
    setUa(ua);

    getData()
    .then((data) => {
      share(data);
    });
  }, []);

  useEffect(() => {
    // isPc & !isBlank
    if (ua === 'isPc' && !isBlank && info.fileUrl) {
      window.location.href = info.fileUrl;
    }
  }, [ua, isBlank, info]);
  

  // 自定义分享卡片
  const share = (data) => {
    axios.get(`/api/wxsign?url=${encodedUrl}`)
    .then(function (res) {
      const { appid, timestamp, nonceStr, signature } = res.data.data;

      wx.config({
        // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appid, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp, // 必填，生成签名的时间戳
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录1
        jsApiList: [
          "updateAppMessageShareData",
        ],
      });
      wx.ready(function () {

        data.dateText = dayjs(data.date).format('YY年M月');

        wx.updateAppMessageShareData({
          title: `${data.customerCompanyName} - ${data.dateText}账单`,
          desc: `记账周期：${data.startDate} ~ ${data.endDate}`,
          link: url,
          imgUrl: 'https://static.owash.cn/images/pc/pdf_share_img.png',
          success: function () {
            // 用户确认分享后执行的回调函数
            console.log("ok");
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
            console.log("error");
          }
        });
      });
    });
  }

  // 获取数据
  const getData = () => {
    return new Promise((resolve) => {
      axios.get(`/api/billpdf?code=${code}`)
      .then((res) => {
        const { data } = res.data;
        const { 
          startDate, endDate, spuList, spuCount, totalPrice, finalPrice, 
          billMode, deliveryDetailList, recycleDetailList, priceLine,
        } = data;
        // console.log(11, data);
        data.dateText = dayjs(data.date).format('YYYY年M月');
        data.month = dayjs(data.date).format('M');
        data.monthText = dayjs(data.date).format('M月');
        data.startDate = dayjs(data.startDate).format('YYYY-MM-DD');
        data.endDate = dayjs(data.endDate).format('YYYY-MM-DD');
        data.addTime = dayjs().format('YYYY-MM-DD HH:mm');

        const dayCount = dayjs(endDate).diff(startDate,'day');
        let monthDayList = Array(dayCount + 1).fill(0).map((i, index) => {
          let date = dayjs(startDate).add(index, 'day');
          date = dayjs(date).format('YYYY-MM-DD');
          return {
            date,
            dateText: dayjs(date).format('M-DD'),
            weekday: CommonUtils.getWeekDay(date),
          }
        });
        
        // console.log(monthDayList);

        const totalPriceInfo = CommonUtils.getPriceInfo({ price: totalPrice });
        data.totalPriceYuan = totalPriceInfo.priceYuan;
        data.totalPriceJiao = totalPriceInfo.priceJiao;
        const newFinalPrice = finalPrice ? finalPrice : totalPrice;
        const finalPriceInfo = CommonUtils.getPriceInfo({ price: newFinalPrice });
        data.finalPriceYuan = finalPriceInfo.priceYuan;
        data.finalPriceJiao = finalPriceInfo.priceJiao;
        data.lastBillPercent = (((totalPrice - data.lastBillTotalPrice) / data.lastBillTotalPrice) * 100).toFixed(1);
        if (data.lastBillPercent > 0) {
          data.lastBillType = 'plus';
        } else {
          data.lastBillType = 'minus';
        }

        // 每日
        let detailList = billMode === 1 ? deliveryDetailList : recycleDetailList;
        let dailyList = [];
        for (let date in detailList) {
          const { rewashCount, totalCount } = detailList[date];
          if (
            (typeof totalCount !== 'undefined' && totalCount !== 0) ||
            (typeof rewashCount !== 'undefined' && rewashCount !== 0)
          ) {
            const obj = {
              date,
              spuList: [],
            }
            for (let spu in detailList[date]['detailList']) {
              const count = detailList[date]['detailList'][spu];
              obj.spuList.push({
                id: parseInt(spu),
                count,
                orderCount: count,
                rewashCount: 0,
              })
            }
            for (let rewashSpu in detailList[date]['rewashDetailList']) {
              const spuListIds = obj.spuList.map(i => i.id);
              const id = parseInt(rewashSpu);
              const rewashCount = parseInt(detailList[date]['rewashDetailList'][rewashSpu]);
              
              if (spuListIds.indexOf(id) === -1) {
                obj.spuList.push({
                  id,
                  count: 0,
                  orderCount: 0,
                })
              }
              obj.spuList = obj.spuList.filter(i => {
                if (i.id === id) {
                  i.rewashCount = rewashCount;
                  i.count = i.orderCount - rewashCount;
                }
                return i;
              });
            }
            dailyList.push(obj);
          }
        }
        dailyList = dailyList.map(i => {
          i.totalOrderCount = i.spuList.reduce((total, item) => total + item.orderCount, 0);
          i.totalRewashCount = i.spuList.reduce((total, item) => total + (item.rewashCount || 0), 0);
          i.totalCount = i.totalOrderCount - i.totalRewashCount;

          // 每天的费用
          i.spuList = i.spuList.map(j => {
            data.spuList.forEach(k => {
              if (j.id === k.spuBaseId) {
                j.totalPrice = j.count * k.price;
              }
            });
            return j;
          });
          i.totalPrice = i.spuList.reduce((total, item) => total + (item.totalPrice || 0), 0);
          i.totalPrice = i.totalPrice.toFixed(2);
          return i;
        });

        let newSpuList = spuList.map(i => {
          i.count = 0;
          spuCount.forEach(j => {
            if (i.spuBaseId === j.spuBaseId) {
              i.count = j.count;
            }
          });
          i.totalPrice = i.count ? (i.count * i.price).toFixed(2) : 0;
          return i;
        });
        newSpuList = newSpuList.map(i => {
          i.id = i.spuBaseId;
          i.dailyInfo = {};

          dailyList.forEach(j => {
            j.spuList.forEach(k => {
              if (i.id === k.id) {
                i.dailyInfo[j.date] = k.count;
              }
            });
          });
          return i;
        });
        // console.log(dailyList);
        // console.log(newSpuList);

        monthDayList = monthDayList.map(i => {
          dailyList.forEach(j => {
            if (i.date === j.date) {
              i.totalCount = j.totalCount;
            }
          });
          return i;
        });

        data.totalCount = newSpuList.reduce((total, item) => total + item.count, 0);
        const dateArr1 = monthDayList.slice(0, 18);
        const dateArr2 = monthDayList.slice(18, monthDayList.length);
        
        // console.log('monthDayList:', monthDayList);

        const priceArr = priceLine.map(i => i.price).filter(i => i !== 0);
        const highestPrice = Math.max.apply(null, priceArr);
        const lowestPrice = Math.min.apply(null, priceArr);
        const averagePrice = (totalPrice / priceLine.length).toFixed(2);
        data.highestPrice = highestPrice;
        data.lowestPrice = lowestPrice;
        data.averagePrice = averagePrice;
        const aboveAverageDays = priceLine.filter(i => i.price >= averagePrice).length;
        data.aboveAverageDays = aboveAverageDays;
        if (priceLine.length > 0) {
          data.highestDate = dayjs(priceLine.filter(i => i.price === highestPrice)[0].date).format('MM月DD日');
          data.lowestDate = dayjs(priceLine.filter(i => i.price === lowestPrice)[0].date).format('MM月DD日');
        }
        // console.log('newSpuList:', newSpuList);
        // newSpuList = newSpuList.concat([
        //   { id: 999, name: '床单1', dailyInfo: {} },
        //   // { id: 999, name: '床单2', dailyInfo: {} },
        //   { id: 999, name: '床单33333333', dailyInfo: {} },
        //   // { id: 999, name: '床单4', dailyInfo: {} },
        //   // { id: 999, name: '床单5', dailyInfo: {} },
        //   // { id: 999, name: '床单6', dailyInfo: {} },
        //   // { id: 999, name: '床单7', dailyInfo: {} },
        //   // { id: 999, name: '床单8', dailyInfo: {} },
        //   // { id: 999, name: '床单9', dailyInfo: {} },
        //   // { id: 999, name: '床单10', dailyInfo: {} },
        //   // { id: 999, name: '床单11', dailyInfo: {} },
        // ]);

        setSpuList(newSpuList);
        setDateArr1(dateArr1);
        setDateArr2(dateArr2);
        setInfo(data);
        setLoading(false);

        // 表格列的宽度
        const spuAndXiaojiW = (1122.52 - 56 - 70 - 130 - 160); // spu 总宽度 + 小计的宽度
        let w = '';
        if (newSpuList.length > 8) {
          w = spuAndXiaojiW / newSpuList.length + 1;
          setXiaojiWidth(w);

        } else {
          setXiaojiWidth(160)
          w = spuAndXiaojiW / newSpuList.length;
        }
        setSpuWidth(w);

        renderColumnChart({ data });
        renderBarChart({ data: newSpuList });


        resolve(data);
      });
    });
  }



  // 柱状图
  const renderColumnChart = ({ data }) => {
    const priceLine = data.priceLine.map(i => {
      i.date = dayjs(i.date).format('M-D');
      return i;
    });

    const columnPlot = new Column("columnChart", {
      data: priceLine,
      xField: "date",
      yField: "price",
      yAxis: false,
      padding: [28, 28, 62, 0],
      columnWidthRatio: 0.3,
      label: {
        position: 'top', // 'top', 'bottom', 'middle',
        offset: 4,
        style: {
          fill: '#000',
        },
        formatter: (item) => {
          if (item.price === data.highestPrice) {
            return '最多';
          } else if (item.price === data.lowestPrice) {
            return '最少';
          }
          return null;
        },
      },
      xAxis: {
        tickInterval: 5,
        label: {
          style: {
            fill: '#000',
            fontWeight: 'bold',
          },
        },
        
      },
      color: ({ type }) => {
        return '#333';
      },
    });

    columnPlot.render();
  }
  // 条形图
  const renderBarChart = ({ data }) => {

    console.log(111, data);
    data = data.sort((a, b) => {
      return a.count - b.count < 0 ? 1 : -1;
    });

    setBarChartH(data.length * 35 > 450 ? 450 : data.length * 35);

    const bar = new Bar("barChart", {
      data,
      xField: "count",
      xAxis: false,
      yField: "name",
      yAxis: {
        label: {
          style: {
            fill: '#000',
          },
        },
      },
      seriesField: "name",
      legend: false,
      padding: [0, 48, 24, 68],
      barWidthRatio: 0.3,
      label: {
        position: 'right', // 'top', 'bottom', 'middle',
        offset: 4,
        style: {
          fill: '#000',
          fontWeight: 'bold',
        },
        animate: {
          update: {
            animation: 'label-update',
            duration: 300,
            easing: 'easeLinear',
          },
        },
        formatter: (item) => {
          return `${item.count} 件`;
        },
      },
      color: ({ type }) => {
        return '#333';
      },
    });

    bar.render();
  }

  // 生成pdf
  const genereatePdf = () => {
    return new Promise((resolve) => {
      setBtnLoading(true);

      const A4W = 841.89;
      const A4H = 595.28;
      const scale = 2;
  
      html2canvas(document.querySelector("#print-wrapper"), {
        scale,
      }).then(function (canvas) {
        var contentWidth = canvas.width / scale;
        var contentHeight = canvas.height / scale;
        // 一页的高度
        let pageHeight = (contentWidth / A4W) * A4H;
        // 剩余高度
        let leftHeight = contentHeight;
        //页面偏移
        let position = 0;
  
        // html页面生成的canvas在pdf中图片的宽高
        var imgWidth = A4W;
        var imgHeight = (A4W / contentWidth) * contentHeight;
  
        var pageData = canvas.toDataURL("image/webp", 1.0);
        var pdf = new jsPDF({
          orientation: "landscape",
          unit: "pt",
          format: "a4",
        });
  
        // 当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "WEBP", 0, 0, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            // console.log("分页", leftHeight, pageHeight, imgHeight, position);
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= A4H;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
  
        setBtnLoading(false);

        resolve(pdf);
      });
    })
  }

  // 打印原文件
  const printPdf = () => {
    genereatePdf()
    .then((pdf) => {
      pdf.autoPrint();
      window.location.href = pdf.output('bloburl');
    });
  }

  // 下载pdf文件 
  const downloadPdf = () => {
    genereatePdf()
    .then((pdf) => {
      const filename = `${info.customerCompanyName}_${dayjs(info.date).format('YY年M月')}账单.pdf`;
      pdf.save(filename);
    });
  }

  // 几个组件
  const DetailTable = ({ showTfoot, dateArr = dateArr1 }) => {
    return (
      <table className={styles.table}>
        <thead>
          <tr>
            <th className="font-bold">日期</th>
            {spuList.map(i => {
              return (
                <th
                  className="font-bold"
                  key={i.spuBaseId}
                  style={{ width: spuWidth }}
                >
                  {i.name}
                </th>
              )
            })}
            <th
              className="font-bold"
              style={{ width: xiaojiWidth }}
            >
              小计
            </th>
          </tr>
        </thead>
        <tbody>
          {dateArr.map((i, index) => {
            return (
              <tr key={i.dateText}>
                <td>
                  <span className="font-bold text-lg">{i.dateText}</span>
                  <span className="font-bold text-sm ml-2">{i.weekday}</span>
                </td>
                {spuList.map(spu => {
                  return (
                    <td key={spu.id}>{spu.dailyInfo[i.date] || '-'}</td>
                  )
                })}
                <td className={i.totalCount ? 'font-bold' : ''}>
                  {i.totalCount || '-'}
                </td>
              </tr>
            )
          })}
          
        </tbody>
        {showTfoot && (
          <tfoot>
            <tr>
              <td>
                <span className="font-bold text-lg">总数</span>
                <span className="text-sm">（件）</span>
              </td>
              {spuList.map(i => {
                return (
                  <td key={i.spuBaseId}>{i.count}</td>
                )
              })}
              <td>{info.totalCount}</td>
            </tr>
            <tr>
              <td>
                <span className="font-bold text-lg">单价</span>
                <span className="text-sm">（元）</span>
              </td>
              {spuList.map(i => {
                return (
                  <td key={i.spuBaseId}>{i.price}</td>
                )
              })}
              <td></td>
            </tr>
            <tr>
              <td>
                <span className="font-bold text-lg">总计</span>
                <span className="text-sm">（元）</span>
              </td>
              {spuList.map(i => {
                return (
                  <td key={i.spuBaseId}>{i.totalPrice}</td>
                )
              })}
              <td>{info.totalPrice}</td>
            </tr>
            <tr>
              <td colSpan={spuList.length + 2}>
                <div className="flex justify-between items-center">
                  <span className="font-bold text-lg">实际应付</span>
                  <span className="font-bold text-lg">{info.finalPriceYuan}
                    <span className="text-sm">{info.finalPriceJiao} 元</span>
                  </span>
                </div>
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    )
  };

  const Footer = ({ page = 1 }) => {
    return (
      <div className={styles.footer}>
        <div className={styles.footerLeft}>{info.factoryCompanyName}</div>
        <div className={styles.footerRight}>
          {info.customerCompanyName} {info.monthText}账单 
          <span className="font-bold ml-5">{page}/3</span>
        </div>
      </div>
    )
  }
  
  const TableTitle = () => {
    return (
      <div className="flex justify-between mb-4">
        <div className="flex-1 flex items-center">
          <TitleSvg month={info.month} type="tableTitle" />
          
          <span className="text-xl" style={{ marginLeft: 46, marginTop: -2 }}>
            {info.startDate} ~ {info.endDate}
          </span>
        </div>
        <div className="font-bold text-2xl">{info.customerCompanyName}</div>
      </div>
    )
  }

  const A4Divider = () => {
    return (
      <>
        {!isBlank && <div data-html2canvas-ignore="true" className={styles.a4Divider} />}
      </>
    )
  }

  const A4Loading = () => {
    return (
      <div className="flex justify-center items-center" style={{ height: '100%' }}>
        <Spin />
      </div>
    )
  }

  return (
    <div className={styles.page} style={{ paddingBottom: !isBlank ? 60 : 0 }}>
      {!isBlank && (
        <>
          {ua === 'isPc' ? (
            <>
              {/* <div className={styles.unprintWrapper}>
                <span className="text-sm text-gray-500 mr-6">如需打印或下载，请打开该文档的PDF原文件。</span>
                {btnLoading ? (
                  <span>
                    <Spin />
                    <span className="text-xs text-gray-400 ml-2">加载中，请稍候...</span>
                  </span>
                ) : (
                  <span className="flex items-center">
                    <span className="flex items-center cursor-pointer mr-4" onClick={() => { printPdf() }} >
                      <svg style={{ width: 16, height: 16 }} t="1640765009657" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2787" width="64" height="64"><path d="M905.185809 178.844158C898.576738 172.685485 891.19337 165.824412 883.21687 158.436127 860.422682 137.322863 837.434925 116.207791 815.697647 96.487895 813.243072 94.261877 813.243072 94.261877 810.786411 92.037081 781.783552 65.781062 757.590948 44.376502 739.713617 29.293612 729.254178 20.469111 721.020606 13.860686 714.970549 9.501727 710.955023 6.608611 707.690543 4.524745 704.47155 2.998714 700.417679 1.07689 696.638044-0.094029 691.307277 0.005928 677.045677 0.273349 665.6 11.769337 665.6 26.182727L665.6 77.352844 665.6 128.522961 665.6 230.863194 665.6 256.448252 691.2 256.448252 896 256.448252 870.4 230.863194 870.4 998.414942 896 972.829884 230.381436 972.829884C187.90385 972.829884 153.6 938.623723 153.6 896.20663L153.6 26.182727 128 51.767786 588.8 51.767786C602.93849 51.767786 614.4 40.312965 614.4 26.182727 614.4 12.05249 602.93849 0.597669 588.8 0.597669L128 0.597669 102.4 0.597669 102.4 26.182727 102.4 896.20663C102.4 966.91021 159.652833 1024 230.381436 1024L896 1024 921.6 1024 921.6 998.414942 921.6 230.863194 921.6 205.278135 896 205.278135 691.2 205.278135 716.8 230.863194 716.8 128.522961 716.8 77.352844 716.8 26.182727C716.8 39.813762 705.748075 50.91427 692.267725 51.167041 687.705707 51.252584 685.069822 50.435995 682.52845 49.231204 682.259458 49.103682 683.344977 49.796618 685.029451 51.010252 689.779394 54.432502 697.145822 60.34494 706.686383 68.394196 724.009052 83.009121 747.816448 104.072869 776.413589 129.961594 778.850014 132.168064 778.850014 132.168064 781.285216 134.376514 802.876774 153.964212 825.739479 174.96442 848.413564 195.966437 856.350957 203.3185 863.697005 210.144893 870.269888 216.269843 874.209847 219.941299 877.019309 222.565641 878.499674 223.951409 888.81866 233.610931 905.019017 233.081212 914.684179 222.768247 924.349344 212.455283 923.819315 196.264383 913.500326 186.604861 911.981323 185.182945 909.155025 182.542876 905.185809 178.844158ZM102.4 461.128719 0 461.128719 0 896.074709 512 896.074709 1024 896.074709 1024 461.128719 153.6 461.128719 153.6 460.531049 102.4 460.531049 102.4 461.128719ZM208.2 711 208.2 819.2 157.6 819.2 157.6 528 269 528C301.533495 528 327.366571 536.466581 346.5 553.4 365.633429 570.333419 375.2 592.733195 375.2 620.6 375.2 649.133476 365.833427 671.333254 347.1 687.2 328.366573 703.066746 302.133502 711 268.4 711L208.2 711ZM208.2 670.4 269 670.4C287.00009 670.4 300.733286 666.166709 310.2 657.7 319.666714 649.233291 324.4 637.000079 324.4 621 324.4 605.266588 319.600047 592.700047 310 583.3 300.399951 573.899953 287.200083 569.066669 270.4 568.8L208.2 568.8 208.2 670.4ZM419.4 819.2 419.4 528 505.4 528C531.133461 528 553.966566 533.733276 573.9 545.2 593.833434 556.666724 609.266611 572.933229 620.2 594 631.133389 615.066771 636.6 639.199863 636.6 666.4L636.6 681C636.6 708.600139 631.100055 732.866562 620.1 753.8 609.099945 774.733438 593.433436 790.866609 573.1 802.2 552.766564 813.533391 529.466799 819.2 503.2 819.2L419.4 819.2ZM470 568.8 470 778.8 503 778.8C529.533466 778.8 549.89993 770.500083 564.1 753.9 578.30007 737.299917 585.533331 713.466822 585.8 682.4L585.8 666.2C585.8 634.599842 578.933402 610.46675 565.2 593.8 551.466598 577.13325 531.533463 568.8 505.4 568.8L470 568.8ZM854.8 695.8 737.6 695.8 737.6 819.2 687 819.2 687 528 872 528 872 568.8 737.6 568.8 737.6 655.4 854.8 655.4 854.8 695.8Z" p-id="2788" fill="#3A81F6"></path></svg>
                      <span className={styles.btn}>打印</span>
                    </span>
                    <span className="flex items-center cursor-pointer" onClick={() => { downloadPdf() }} >
                      <svg style={{ width: 16, height: 16 }} t="1640925299318" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2319" width="64" height="64"><path d="M505.7 661c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z" p-id="2320" fill="#3A81F6"></path><path d="M878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" p-id="2321" fill="#3A81F6"></path></svg>
                      <span className={styles.btn}>下载</span>
                    </span>
                  </span>
                )}
              </div> */}
            </>
          ) : (
            <div className={styles.unprintWrapperMobile}>
              
              <span style={{ fontSize: 40 }} className="text-gray-400"
                onClick={() => {
                  togglePcTip(true);
                }}
              >
                <QuestionCircleOutlined /> 如需打印，请在电脑上打开此链接
              </span>
              <span className="flex">
                <span className="flex items-center mr-8">
                  <svg style={{ width: 40, height: 40 }} t="1640925299318" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2319" width="64" height="64"><path d="M505.7 661c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z" p-id="2320" fill="#3A81F6"></path><path d="M878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" p-id="2321" fill="#3A81F6"></path></svg>
                  <a style={{ fontSize: 40 }} className={styles.btnMobile} href={info.fileUrl}>下载</a>
                </span>
                <span
                  className="flex items-center"
                  onClick={() => {
                    toggleShareTip(true);
                  }}
                >
                  <svg style={{ width: 40, height: 40 }} t="1642144859402" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2163" width="64" height="64"><path d="M71.9 909.8c-2.2 8.4-12.5 5.9-11.9-2.9 13.1-187 71.1-284.1 128.1-352.8C274.7 449.9 469.8 352.7 604 341.3c10.6-0.9 18.9-11.7 18.9-24.8V157.9c0-21.7 21.1-32.9 34.1-18.2l299.5 339.5c9 10.2 8.6 27.6-0.8 37.2L662 817.6c-13.2 13.5-33.3 2-33.3-19V604.3c0-12.9-8.1-23.7-18.6-24.7-85.7-8.5-287.5 10.3-369.1 70.2-34.8 25.4-129.8 112.4-169.1 260z" p-id="2164" fill="#10B981"></path></svg>
                  <span className={styles.btnShare}>转发</span>
                </span>
              </span>
            </div>
          )}
        </>
      )}
      <div className={styles.wrapper}>
        <div id="print-wrapper">
          {/* 第1页 */}
          <div className={styles.a4}>
            {loading ? (
              <A4Loading />
            ) : (
              <div className={styles.page1}>
                <div className={styles.page1Title}>{info.customerCompanyName}</div>
                <div className={styles.page1TitleDivider} />
                <div style={{ fontSize: 48 }}>{info.dateText}洗涤账单</div>
                <div style={{ fontSize: 24 }}>{info.startDate} ~ {info.endDate}</div>
                <div className="font-bold" style={{ fontSize: 28, marginTop: 140, marginBottom: 12 }}>
                  {info.factoryCompanyName}
                </div>
                <div className="text-xl">账单于 {currentTime} 通过布凡智洗小程序生成</div>
              </div>
            )}
          </div>
          <A4Divider />

          {/* 第2页 */}
          <div className={styles.a4}>
            {loading ? (
              <A4Loading />
            ) : (
              <>
                <div className={styles.page2Header}>
                  <div className={styles.page2HeaderLeft}>
                    <TitleSvg month={info.month} />
                    <span className={styles.page2Price}>
                      <span className={styles.page2PriceYuan}>{info.totalPriceYuan}</span>
                      <span className={styles.page2PriceJiao}>{info.totalPriceJiao} 元</span>
                    </span>
                  </div>
                  {/* todo */}
                  {/* {info.lastBillTotalPrice !== 0 && (
                    <div className={styles.page2HeaderRight}>
                      相比上月 
                      <span className="font-bold ml-2">
                        {info.lastBillPercent}%
                      </span>
                    </div>
                  )} */}
                </div>
                <div className={styles.page2Body}>
                  <div className={styles.page2Left}>
                    {/* 本月每日费用趋势 */}
                    <svg className={styles.page2BodyTitle} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 916.53 103.73"><g id="图层_2" data-name="图层 2"><g id="图层_1-2" data-name="图层 1"><path d="M31.88,33.23H45.36q-6.3,14.82-14.37,31Q22.91,80.83,15.72,93.85H0A430.49,430.49,0,0,0,31.88,33.23Zm37.72-18h41.77L110,25.6H68.26L62.42,70.5H79.48L78.14,80.83H60.62l-3.14,22.45H43.56L46.7,80.83H29.64L31,70.5H48.5l5.84-44.9H12.57l1.8-10.33H56.13L57.93.45H71.85Zm5,18H88a563.25,563.25,0,0,0,16.16,60.62H89.36A541.55,541.55,0,0,1,74.55,33.23Z"/><path d="M212,1.8a16.13,16.13,0,0,1,5.83.89Q220,4,219.14,9l-13.47,93.41H175.13l-3.59-9.88h22l3.6-23.36H148.19a226.09,226.09,0,0,1-10.33,33.24H122.59a205.42,205.42,0,0,0,10.33-26,226.65,226.65,0,0,0,6.29-28.29q3.14-19.75,5.84-46.25ZM150,59.73h48.5l3.14-19.31h-48l-1.35,9Zm52.09-48H157.17l-2.69,18.86H203l2.24-15.27a4.06,4.06,0,0,0,0-2.7C204.92,12,203.87,11.68,202.08,11.68Z"/><path d="M265.85,18a42.72,42.72,0,0,1-9,9h62c2.4,0,4,.45,4.94,1.35q.9,1.8.45,6.29L321.08,53H335l-1.35,9.43H319.73l-3.14,17.06H331l-1.8,9.88H314.79l-2.69,14.37H282.46l-3.14-9.88h21.55l.9-4.49H240.25L247,62.42H233.51L234.86,53h14.37l5.84-24.25a86.94,86.94,0,0,1-18,9.88L239.8,24.7a45.51,45.51,0,0,0,13-9.88A73.6,73.6,0,0,0,263.15.45h13.92l-4.49,8.08h65.56L336.8,18Zm37.72,61.52,3.14-17.06H260l-4,17.06Zm5.83-43.11H265.85L262.25,53h46.26l2.24-14.37V37.27C310.75,36.68,310.3,36.37,309.4,36.37Zm-30.08,40a106.53,106.53,0,0,1-9.43-10.78h14.37a129.45,129.45,0,0,0,11.22,10.78Zm21.1-26.05H284.26q-4.5-4.93-9.88-11.22h14.37A83.48,83.48,0,0,0,300.42,50.29Z"/><path d="M441.43,2.25a17.7,17.7,0,0,1,6.28.89q2.25,1.35,1.35,6.29l-11.68,92.06H352.51L367.33,2.25Zm-73.2,88.46h56.58l4.49-35.48-55.68.45ZM431.1,13H379.9L375,44.46h55.68l3.59-27.84a4.06,4.06,0,0,0,0-2.7A4.38,4.38,0,0,0,431.1,13Z"/><path d="M520.46,84H529A193.4,193.4,0,0,0,546.06,94.3a163.11,163.11,0,0,0,19.31,9.43h-23.8q-10.79-5.39-24.25-16.16A41.38,41.38,0,0,1,511,93.4a55.66,55.66,0,0,1-9.43,5.84,98.16,98.16,0,0,1-10.33,4.49H462.08q31-9,42.21-18.86a26.68,26.68,0,0,0,6.29-8.08,14,14,0,0,0,.9-2.7,13.6,13.6,0,0,0,.45-3.14h13A32.16,32.16,0,0,1,520.46,84Zm43.11-48.49a8.53,8.53,0,0,1,4.49.89,4.41,4.41,0,0,1,.9,3.15q-.9,5.38-3.59,16.16H547l-2.69-7.63h10.33l.9-3.59V44c0-.3-.61-.45-1.8-.45H539.32L538,55.23H525.4l1.8-11.67H510.13a37.25,37.25,0,0,1-5.84,6.29,28,28,0,0,1-7.18,5.38H477.35q4.48-2.23,10.33-5.83a40,40,0,0,0,8.08-5.84H476l6.74-22h22.9L507,16.17h-26.5L478.7,7.63h29.64q.44-2.24.89-7.18h12.13l-.9,7.18h11.67L533,.45h12.58l-1.35,7.18h18a11.35,11.35,0,0,1,4.94.9,4.38,4.38,0,0,1,1.8,2.25v3.14l-2.69,15.72h-24.7l-.9,5.84Zm-22.9,53.88,2.69-21.1v-.9q0-.45-1.35-.45H494l-3.15,22.45h-13l4.49-31.88h66c3.6,0,6,.6,7.19,1.8s1.64,3.29,1.34,6.28l-3.14,23.8Zm-48.5-59.72-1.8,5.84h10.78a48.07,48.07,0,0,0,2.24-5.84Zm21.55,5.84h14.37l.9-5.84H516A33.73,33.73,0,0,1,513.72,35.48Zm5.39-19.31-.9,5.38h12.13l.45-5.38Zm35,0H543.36l-.9,5.38H555l.9-4C555.94,16.62,555.33,16.17,554.14,16.17Z"/><path d="M678.53,2.25a17.7,17.7,0,0,1,6.28.89q1.8,1.35.9,6.29l-13,92.06H648l-3.14-10.33h15.72l3.14-21.56H638.56l-4.49,31.89h-13l4.49-31.89H598.6q-4.05,17.52-8.54,31.89H575.69a426.47,426.47,0,0,0,13-48,486.21,486.21,0,0,0,7.63-51.19ZM600.84,59.73h26l2.69-18.87H604.43Zm32.78-47.16H608.48L605.78,31h25.15Zm6.29,47.16h25.15l3.14-18.87H642.6Zm31.88-43.56a4.06,4.06,0,0,0,0-2.7c-.3-.6-1.35-.9-3.14-.9H646.2L644,31h25.6Z"/><path d="M736.63,48.29l-1.71,13.2H750.7l-1.28,9.24H733.64l-2.56,17.15a57.57,57.57,0,0,0,14.08,3.53q8.52,1.32,27.29,1.31H794.2l-4.26,11H769.46A153,153,0,0,1,745.58,102,64.45,64.45,0,0,1,726,95.8a59.84,59.84,0,0,1-15.35-10.56q-2.57,9.26-6,18.48H692.7a284.1,284.1,0,0,0,15.35-50.15h10.66L713.6,74.68a38.15,38.15,0,0,0,6.82,7l4.69-33.43ZM748,23.55H734.9l-2,14.14h15.49l-1.2,10.36H702.74l1.19-10.36h18.26l1.6-14.14h-15.5l1.2-9.9H725L726.56.93h10.73l-1.6,12.72H749.2ZM773,34.1a76.28,76.28,0,0,0,7.92-13.36,3.67,3.67,0,0,0,.44-1.38A1.78,1.78,0,0,0,780,18.9H768.59a89.4,89.4,0,0,1-11,10.59,64.91,64.91,0,0,1-12.31,7.38l4.4-14.75a53.17,53.17,0,0,0,11-9.67,35.4,35.4,0,0,0,7-12h11.88a65.89,65.89,0,0,1-4.4,9.21h17.59a7.89,7.89,0,0,1,2.64.46,2.14,2.14,0,0,1,1.33,2.3q0,2.78-3.08,7.37-4.39,8.3-8.36,14.28Zm17,1.38h1.51c3,0,5,.52,6,1.55q1.51,2,1,6.25L791,85.83H745.8l1.51-8.19h31.61l2-13.28h-27.1l1.51-8.59h27.6l1.5-10.15c.34-1-.17-1.56-1.5-1.56h-28.6l1.5-8.58Z"/><path d="M899.47,64.66c2.69,0,4.49.61,5.39,1.8s1.19,3.14.89,5.84q-2.68,20.2-4.49,31.43H864.44l-3.14-9.88h27.84l2.69-17.51c.3-1.19-.15-1.8-1.34-1.8H857.25A40.47,40.47,0,0,1,851,83.08,98.87,98.87,0,0,1,839.74,94.3a102.6,102.6,0,0,1-13.47,9.43h-22a124.35,124.35,0,0,0,22.9-13.47q11.22-8.52,16.16-15.72H814.59l-2.24-9.88h34.58a37.66,37.66,0,0,0,1.34-8.08h13A38.19,38.19,0,0,1,860,64.66Zm-85.33-35,18.42-1.35,1.34-9.43H818.19l.89-9h16.17L836.6,0h11.67l-1.34,9.88H858.6l-.9,9H846l-.9,8.08,12.12-1.79-1.34,9.43-12.13,1.34L840.64,57h-22l-2.7-9.43h13.92l1.35-9.88-13.47,1.35ZM904.86,45.8h11.67l-4,9.43H891.83l.45-3.14H879.71a40.14,40.14,0,0,1-5.84-7.18q-4.5,5.39-9.43,10.32H847.82a164.7,164.7,0,0,0,18.87-19.31L858.6,23.35h11.23l2.69,4a22.79,22.79,0,0,0,3.15-7.18h-13l-1.79-9.43h17.06q.9-5.4,1.35-10.78h12.12A89.5,89.5,0,0,1,890,10.78h13q4.49,0,5.84,1.35c.59,1.19.74,3.29.44,6.28ZM897.22,22c.3-1.19-.15-1.79-1.35-1.79h-8.08a72.83,72.83,0,0,1-7.63,17.06Q886,44,892.73,50.74Z"/></g></g></svg>
                    
                    <div id="columnChart" style={{ height: 300 }}></div>
                    <ul style={{ paddingLeft: 20 }}>
                      <li className="text-xl mb-2">本月日均费用为 
                        <span className="font-bold"> {info.averagePrice} 元</span>
                        ，有 
                        <span className="font-bold"> {info.aboveAverageDays}天 </span>
                        超过了日均费用
                      </li>
                      <li className="text-xl mb-2">单日费用最多在 
                        <span className="font-bold"> {info.highestDate}</span>
                        ，达到了
                        <span className="font-bold"> {info.highestPrice}元 </span>
                      </li>
                      <li className="text-xl">单日费用最少在 
                        <span className="font-bold"> {info.lowestDate}</span>
                        ，只有
                        <span className="font-bold"> {info.lowestPrice}元 </span>
                      </li>
                    </ul>
                  </div>
                  <div className={styles.page2Right}>
                    {/* 本月洗涤物占比 */}
                    <svg className={styles.page2BodyTitle} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 797.23 106.63"><g id="图层_2" data-name="图层 2"><g id="图层_1-2" data-name="图层 1"><path d="M31.88,34.58H45.36Q39.06,49.4,31,65.57,22.91,82.19,15.72,95.21H0A430.61,430.61,0,0,0,31.88,34.58Zm37.72-18h41.77L110,27H68.26L62.42,71.86H79.48L78.14,82.18H60.62l-3.14,22.46H43.56L46.7,82.18H29.64L31,71.86H48.5L54.34,27H12.57l1.8-10.33H56.13L57.93,1.8H71.85Zm5,18H88a563.46,563.46,0,0,0,16.16,60.63H89.36A542.29,542.29,0,0,1,74.55,34.58Z"/><path d="M212,3.15a15.9,15.9,0,0,1,5.83.9q2.25,1.35,1.35,6.28l-13.47,93.41H175.13l-3.59-9.88h22l3.6-23.35H148.19a226.34,226.34,0,0,1-10.33,33.23H122.59a204.23,204.23,0,0,0,10.33-26,225.85,225.85,0,0,0,6.29-28.29q3.14-19.76,5.84-46.25ZM150,61.08h48.5l3.14-19.31h-48l-1.35,9Zm52.09-48H157.17l-2.69,18.86H203l2.24-15.27a4,4,0,0,0,0-2.69C204.92,13.33,203.87,13,202.08,13Z"/><path d="M250.82,66h12a377.87,377.87,0,0,1-18.5,40H231A368.77,368.77,0,0,0,250.82,66ZM265,57.07H251.67l-9-24.45h11.61Zm4.3-29.79h-12.9L246.08,4.17h12Zm25.27,32.09Q289.12,87.92,271,106.63H255.38Q267.73,94,274.25,83.24a72,72,0,0,0,9.07-23.87Zm19-9.3H341L339.13,61.4H265.61l1.88-11.33h31.77l3.11-20.86H289.91q-3.75,6.56-8.09,13.11H265.61A131,131,0,0,0,276.83,25a92.18,92.18,0,0,0,8.72-19.67h15.57q-3.74,8.94-5.6,13.11h8.09L306.73,0h13.7l-3.11,18.48h22.42l-1.86,10.73h-21.8Zm4.93,9.3-3.62,36h24.68l-3.27,11.23H302.56l5.08-47.26Z"/><path d="M366,65h12.3Q368.2,89.5,359.43,105.07h-13.6A363.44,363.44,0,0,0,366,65Zm14.49-8.9H366.89l-9.21-24.48h11.85Zm4.39-29.82H371.72L361.18,3.16h12.3Zm7.5,49.5H404.6a229.08,229.08,0,0,1-14.43,24.71H376.85Q387.58,87.1,392.39,75.8ZM381.47,52a240.38,240.38,0,0,0,32.32-16.62l-11.08-10-5.84,6.65h-12C398.6,16.54,404.81,6.58,407.48,2.14H420l-5.54,8.31h31.78c2.05,0,3.08,1,3.08,2.91a15.23,15.23,0,0,1-.62,5,8.11,8.11,0,0,1-2.46,3.74A195,195,0,0,1,429.87,35.8C438.7,41.62,446.52,47,455.35,52H436.26L420.87,41.2c-6.57,3.88-12.24,7.48-19,10.81Zm8.7,9.55h22.94l1.48-11.71H425l-1.11,11.71H445.3l-1.11,9.22H422.73l-4.45,33.91H399.42l-2.59-9.21h11.84L412,70.78H389.06Zm23.39-38.23,8.62,7.07c5.13-3.6,8.54-7.07,12.24-10.4a1.36,1.36,0,0,0,.3-.82H407.94l-3.39,4.15ZM427.17,75.8H437.9a117.63,117.63,0,0,0,11.47,24.71H437.16A158.15,158.15,0,0,1,427.17,75.8Z"/><path d="M504.29,62,494,66.92l-5.84,38.17H476l4.94-32.78-19.31,7.18L463,68.26q10.32-3.58,19.76-7.18l4-27.84h-5.39A100.48,100.48,0,0,1,476,51.65H464.78a190.05,190.05,0,0,0,9.88-40.87h10.77q-.9,6.74-1.79,13h4.94L491.27,2.7h12.12l-3.14,21.11h9.43l-1.34,9.43h-9.43l-3.6,22.45,10.33-4.49Zm58.38-43.56a13.89,13.89,0,0,1,5.84.9,4.31,4.31,0,0,1,1.35,3.14,40.4,40.4,0,0,1-.45,5.39q-4.5,35-11.23,77.24H531.69L529,95.21H547.4a31.84,31.84,0,0,0,.9-5.39q.45-3.58,3.6-22.9t5.38-37.27q0-1.8-.9-1.8h-1.79q-5,30.09-18,48.05-13,18.42-38.17,29.19l2.69-14.37a87.94,87.94,0,0,0,16.17-10.33,57.71,57.71,0,0,0,12.57-13,86.68,86.68,0,0,0,8.53-17.51,137.66,137.66,0,0,0,5.84-22h-3.59a93.12,93.12,0,0,1-7.19,20.66,69,69,0,0,1-11.67,15.71,80.26,80.26,0,0,1-17.52,13l2.25-14.36q17.51-11.22,23.8-35H527.2A70.6,70.6,0,0,1,520,37.28a43.45,43.45,0,0,1-8.08,7.18,28.05,28.05,0,0,1-7.19,5.39L507.44,35a52.84,52.84,0,0,0,12.12-14.37A72.21,72.21,0,0,0,526.75,1.8h12.57A118.48,118.48,0,0,1,533,18.42Z"/><path d="M611.54,104.58H585.76l5.35-48.84h71c3.56,0,6,.85,7.3,2.54q1.46,3.18.48,10.78l-3.4,35.52ZM602.3,68.43,599.87,91.9h55.45L656.78,71c.32-1.7-.17-2.54-1.46-2.54Zm17-12,7.64-54.17h13.93l-3.15,23h45.83L682.18,35.7H635.89L633.2,56.46Z"/><path d="M715.35,49.4l-6.28,42.21H738.7l-4.49,11.23h-40L708.62,4.05h13L716.7,38.62H745L743.64,49.4Zm80-8.89q-15.09,6.59-32.07,12.28l-6.12,39.95h32.53L785,103.27H741.59l15.1-99.19h13.67L764.7,40.51A337.86,337.86,0,0,0,797.23,26.9Z"/></g></g></svg>
                    <div id="barChart" style={{ height: barChartH }}></div>
                  </div>
                </div>
                <Footer />
              </>
            )}
          </div>
          <A4Divider />
          
          {/* 第3页 */}
          <div className={styles.a4}>
            {loading ? (
              <A4Loading />
            ) : (
              <>
                <TableTitle />
                <DetailTable />
                <Footer page="2" />
              </>
            )}
          </div>
          <A4Divider />

          {/* 第4页 */}
          <div className={styles.a4}>
            {loading ? (
              <A4Loading />
            ) : (
              <>
                <TableTitle />
                <DetailTable showTfoot dateArr={dateArr2} />
                <Footer page="3" />
              </>
            )}
          </div>
        </div>
      </div>
      
      {/* 如何在电脑上打印文件 */}
      {pcTipVisible && (
        <div className={styles.pcTip}>
          <div className={styles.pcTipWrapper}>
            <div className={styles.title}>如何在电脑上打印文件</div>
            <div className={styles.body}>
              <ul>
                <li className={styles.li}>
                  <div className={styles.liIndex}>1</div>
                  <div>
                    <div className={styles.liTitle}>将页面转发给自己</div>
                    <div className={styles.liDesc}>点击页面右上角「转发」，<br />把当前页面转发给自己。</div>
                  </div>
                </li>
                <li className={styles.li}>
                  <div className={styles.liIndex}>2</div>
                  <div>
                    <div className={styles.liTitle}>登录电脑微信下载文档</div>
                    <div className={styles.liDesc}>在电脑上登录微信桌面版，<br />点击链接，自动下载PDF文件。</div>
                  </div>
                </li>
                <li className={styles.li}>
                  <div className={styles.liIndex}>3</div>
                  <div>
                    <div className={styles.liTitle}>在本地打印文件</div>
                    <div className={styles.liDesc}>打开已下载的文件并打印，<br />确保电脑已连接打印机。</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <CloseCircleFilled 
            className={styles.close} 
            onClick={() => {
              togglePcTip(false);
            }}
          />
        </div>
      )}

      {/* 右上角转发 */}
      {shareTipVisible && (
        <div
          className={styles.shareTip}
          onClick={() => {
            toggleShareTip(false);
          }}
        >
          <img
            src="https://static.owash.cn/images/pc/weixin_share.png"
            style={{ float: 'right', marginRight: 80 }}
          />
        </div>
      )}
    </div>
  );
}
export default Recyclepdf;
